export default __webpack_public_path__ + "static/media/no-image.b771484f.png";